function Button({children, onClickHandler, renderComponent, isActive}) { 
	return <button className={`btn-tab ${isActive ? 'active' : ''}`} onClick={onClickHandler}>
		{children}
	</button>
}

export default Button;